import React, { useState } from "react";
import axios, { authIsValid } from "../axios";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

function EditUser({ fetchData, userData, setVisibility }) {
  const [cookies, setCookies] = useCookies();
  const navigate = useNavigate();
  const [userToEditData, setUserToEditData] = useState({ ...userData });

  const handleCancel = () => {
    setUserToEditData({ ...userData });
    setVisibility(false);
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(
        `/users/editUser`,
        { ...userToEditData, userId: userToEditData.email },
        { headers: { "x-access-token": cookies.access_token } }
      );
      if (response.data.message) {
        if (authIsValid(response.data.message) === false) {
          navigate("/mixer");
        } else {
          alert(response.data.message);
        }
      } else {
        setUserToEditData({ ...userData });
        fetchData();
        setVisibility(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleEditUserChange = (e) => {
    setUserToEditData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <div className="editUserContainer">
      <div className="editUser row justify-content-center">
        <h5 className="text-center futuraBold" style={{ marginBottom: "20px" }}>
          Edit User
        </h5>
        <form
          onSubmit={handleEditSubmit}
          className="row col-md-12 justify-content-center"
        >
          <div className="form-group col-md-6 col-sm-12 col-xs-12">
            <label
              htmlFor="editUserFirstName"
              className="col-md-4 col-form-label"
            >
              First Name:
            </label>
            <input
              id="editUserFirstName"
              className="form-control input-lg"
              name="firstName"
              type="text"
              required
              value={userToEditData.firstName}
              onChange={(e) => handleEditUserChange(e)}
            />
          </div>
          <div className="form-group col-md-6 col-sm-12 col-xs-12">
            <label
              htmlFor="editUserlastName"
              className="col-md-4 col-form-label"
            >
              Last Name:
            </label>
            <input
              id="editUserLastName"
              className="form-control input-lg"
              name="lastName"
              type="text"
              required
              value={userToEditData.lastName}
              onChange={(e) => handleEditUserChange(e)}
            />
          </div>
          <div className="form-group col-md-6 col-sm-12 col-xs-12">
            <label htmlFor="editUserEmail" className="col-md-4 col-form-label">
              User Email:
            </label>
            <input
              id="editUserEmail"
              className="form-control input-lg"
              name="email"
              type="email"
              required
              value={userToEditData.email}
              onChange={(e) => handleEditUserChange(e)}
            />
          </div>
          <div className="form-group col-md-6 col-sm-12 col-xs-12">
            <label htmlFor="editUserRole" className="col-md-3 col-form-label">
              Role:
            </label>
            <select
              id="editUserRole"
              name="role"
              className="form-select input-lg"
              required
              value={userToEditData.role}
              onChange={(e) => handleEditUserChange(e)}
            >
              <option value="" hidden>
                Choose...
              </option>
              <option value="ADMIN">ADMIN</option>
              <option value="USER">USER</option>
            </select>
          </div>
          <div className="row justify-content-center editUserButtons">
            <button
              className="col-md-3 col-xs-6 btn"
              type="button"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              className="col-md-3 col-xs-6 btn-ryoForest btn btn-md"
              type="submit"
              style={{ minWidth: "68px", marginLeft: "20px" }}
            >
              Edit User
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditUser;
